import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import { closeModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import { selectTriggerAgent } from 'store/Agents/selectors';
import { Status } from '../../../../../Grid/components/UserAgents/components/UserAgent/styled';
import { Wrapper, Top, AgentIcon, Name, Left, Description } from './styled';
import Button from 'shared/ui/Button';
import { CloseIconWrapper, CloseIcon } from 'Screens/Contextualization/Host/components/HostDetail/components/Header/styled';
import { saveAgentToolData } from 'store/Agents/actions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_AGENTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import cloneDeep from 'lodash/cloneDeep';

const Header = ({ toolExpanded, toolToSave }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const agent = useSelector(selectTriggerAgent);
  const name = get(agent, 'name', '');
  const statusValue = get(agent, 'status', '');
  const statusLabel = statusValue ? intl.formatMessage({ id: `agents.item.status.${statusValue}` }) : 'Online';
  const description = get(agent, 'description', '');
  const parameters_data = get(toolToSave, 'parameters_data', {});
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENTS, PERMISSION_TYPES.PATCH));

  const closeDetail = () => dispatch(closeModal(MODAL_AGENT_DETAIL));

  const saveData = () => {
    if (toolExpanded) {
      const toolParamsClone = cloneDeep(parameters_data);
      if (toolParamsClone.severityRange) {
        delete toolParamsClone.severityRange;
      }
      // Remove execution/runtime metadata that comes from GET responses
      delete toolParamsClone.executor_data;
      delete toolParamsClone.workspaces_commands;
      delete toolParamsClone.workspaces_names;
      dispatch(saveAgentToolData(toolExpanded, toolParamsClone));
    }
  };

  useModalShortcuts({
    id: 'agent-detail',
    onSave: allowedByRole ? saveData : undefined,
    onCancel: closeDetail,
    cancelLabel: 'Close'
  });

  return (
    <Wrapper>
      <Top>
        <Left>
          <AgentIcon />
          <Name>{ name }</Name>
          <Status children={ statusLabel } value={ statusValue } noMargin />
        </Left>
          <Button onClick={ saveData } disabled={ !allowedByRole }>Save</Button>
          <CloseIconWrapper onClick={ closeDetail }>
            <CloseIcon />
          </CloseIconWrapper>
      </Top>
      <Description children={ description } />
    </Wrapper>
  );
};

export default Header;
